/* LL: counts come exclusively from the drawer's server-rendered meal config. */
(() => {
  if (customElements.get('ll-meal-bar')) return;
  function textWithCounts(node, template, values) {
    const fragment = document.createDocumentFragment();
    template.split(/(\[count\]|\[add\]|\[total\]|\[singles\]|\[target\])/).forEach(part => {
      const key = part.slice(1, -1);
      if (Object.prototype.hasOwnProperty.call(values, key) && part.startsWith('[')) {
        const strong = document.createElement('strong');
        strong.textContent = values[key];
        fragment.append(strong);
      } else { fragment.append(document.createTextNode(part)); }
    });
    // Avoid duplicate announcements when the drawer class changes without new counts.
    if (node.textContent !== fragment.textContent) node.replaceChildren(fragment);
  }
  customElements.define('ll-meal-bar', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      this.link = this.querySelector('a');
      this.link.addEventListener('click', event => {
        const drawer = document.querySelector('[data-js-site-cart-sidebar]');
        if (typeof drawer?.show !== 'function') return;
        event.preventDefault();
        window.lastFocusedElm = this.link;
        drawer.show();
        drawer.querySelector('[data-js-close]')?.focus();
        this.paint();
      }, { signal: this.controller.signal });
      document.addEventListener('ll:cart:rendered', () => this.paint(true), { signal: this.controller.signal });
      this.addEventListener('pointerenter', () => { this.hovering = true; clearTimeout(this.timer); }, { signal: this.controller.signal });
      this.addEventListener('pointerleave', () => { this.hovering = false; this.resume(); }, { signal: this.controller.signal });
      this.addEventListener('focusin', () => clearTimeout(this.timer), { signal: this.controller.signal });
      this.addEventListener('focusout', event => { if (!this.contains(event.relatedTarget)) this.resume(); }, { signal: this.controller.signal });
      this.observer = new MutationObserver(() => this.paint());
      this.active = false;
      this.lastCounts = null;
      this.paint();
    }
    disconnectedCallback() {
      this.controller?.abort(); this.controller = null; this.observer?.disconnect(); this.drawer = null;
      clearTimeout(this.timer); clearTimeout(this.hideTimer); this.hideTimer = null; this.hovering = false;
    }
    schedule(seconds) {
      clearTimeout(this.timer);
      if (this.dataset.alwaysShow === 'true' || this.hovering || this.contains(document.activeElement)) return;
      this.timer = setTimeout(() => { this.active = false; this.paint(); }, seconds * 1000);
    }
    resume() {
      // focusout fires before activeElement changes; check both pause reasons afterwards.
      queueMicrotask(() => { if (this.isConnected && this.active) this.schedule(3); });
    }
    visibility(show, immediate = false) {
      if (show) {
        clearTimeout(this.hideTimer); this.hideTimer = null;
        if (this.hidden) {
          this.hidden = false;
          void this.offsetWidth;
        }
        this.inert = false;
        this.classList.add('is-visible');
      } else {
        this.inert = true;
        this.classList.remove('is-visible');
        if (immediate || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          clearTimeout(this.hideTimer); this.hideTimer = null; this.hidden = true;
        } else if (!this.hidden && !this.hideTimer) {
          this.hideTimer = setTimeout(() => { this.hidden = true; this.hideTimer = null; }, 200);
        }
      }
    }
    paint(cartRendered = false) {
      const drawer = document.querySelector('#site-cart-sidebar');
      if (drawer !== this.drawer) {
        this.observer.disconnect();
        this.drawer = drawer;
        if (drawer) this.observer.observe(drawer, { attributes: true, attributeFilter: ['class', 'aria-hidden', 'open'] });
      }
      let config;
      try { config = JSON.parse(drawer?.querySelector('[data-ll-meal-config]')?.textContent || '{}'); }
      catch (_) { config = {}; }
      const singles = Number(config.singles) || 0;
      const total = Number(config.total) || 0;
      if (cartRendered && this.lastCounts && (singles !== this.lastCounts.singles || total !== this.lastCounts.total)) {
        this.active = true;
        this.schedule(Math.max(5, Math.min(30, Number(this.dataset.autoHideSeconds) || 10)));
      }
      if (cartRendered || !this.lastCounts) this.lastCounts = { singles, total };
      const open = Boolean(drawer?.opened || drawer?.classList.contains('sidebar--opened'));
      this.link.setAttribute('aria-expanded', String(open));
      this.visibility(total > 0 && !open && (this.dataset.alwaysShow === 'true' || this.active), open || total <= 0);
      if (total <= 0) return;
      const add = (15 - singles % 15) % 15;
      const complete = singles > 0 && add === 0;
      this.style.setProperty('--ll-progress', `${singles > 0 ? complete ? 100 : (singles % 15) / 15 * 100 : 0}%`);
      this.classList.toggle('is-ready', complete);
      this.querySelector('[data-meal-bar-progress]').hidden = singles <= 0;
      const values = { count: singles, singles, add, total, target: singles + add };
      textWithCounts(this.querySelector('[data-meal-bar-total]'), total === 1 && this.dataset.primaryOne ? this.dataset.primaryOne : this.dataset.primary, values);
      textWithCounts(this.querySelector('[data-meal-bar-message]'), singles === 0 ? this.dataset.packagesOnly : add ? this.dataset.incomplete : this.dataset.complete, values);
    }
  });
})();
